if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal, ayaq-premium-quick-add');
          const ayaqCartModal = document.querySelector('ayaq-cart-modal');
          if (ayaqCartModal) {
            if (this.cart) {
              this.cart.classList.remove('is-empty');
              const sections = response.sections || {};
              this.cart.getSectionsToRender().forEach((section) => {
                const sectionHtml = sections[section.id];
                const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
                if (sectionElement && sectionHtml) {
                  const rawHtml = typeof this.cart.getSectionInnerHTML === 'function'
                    ? this.cart.getSectionInnerHTML(sectionHtml, section.selector)
                    : new DOMParser().parseFromString(sectionHtml, 'text/html').querySelector(section.selector || '.shopify-section')?.innerHTML;
                  if (rawHtml) {
                    sectionElement.innerHTML = rawHtml.replace(/viewbox=/g, 'viewBox=');
                  }
                }
              });
              if (typeof window.updateHeaderIconColors === 'function') {
                window.updateHeaderIconColors();
              }
              const drawerInner = this.cart.querySelector('.drawer__inner');
              if (drawerInner) drawerInner.classList.remove('is-empty');

              const items = this.cart.querySelector('cart-drawer-items');
              if (items) items.classList.remove('is-empty');

              const checkoutButton = this.cart.querySelector('#CartDrawer-Checkout');
              if (checkoutButton) checkoutButton.removeAttribute('disabled');
            }
            if (quickAddModal) quickAddModal.hide(true);
            ayaqCartModal.openWithItem(response);
          } else if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          this.handleErrorMessage(window.cartStrings?.error);
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

var addWorkDays = function (startDate, days) {
  if (isNaN(days)) {
    console.log("Value provided for \"days\" was not a number");
    return
  }
  if (!(startDate instanceof Date)) {
    console.log("Value provided for \"startDate\" was not a Date object");
    return
  }
  // Get the day of the week as a number (0 = Sunday, 1 = Monday, .... 6 = Saturday)
  var dow = startDate.getDay();
  var daysToAdd = parseInt(days);
  // If the current day is Sunday add one day
  if (dow == 0)
    daysToAdd++;
  // If the start date plus the additional days falls on or after the closest Saturday calculate weekends
  if (dow + daysToAdd >= 6) {
    //Subtract days in current working week from work days
    var remainingWorkDays = daysToAdd - (5 - dow);
    //Add current working week's weekend
    daysToAdd += 2;
    if (remainingWorkDays > 5) {
      //Add two days for each working week by calculating how many weeks are included
      daysToAdd += 2 * Math.floor(remainingWorkDays / 5);
      //Exclude final weekend if remainingWorkDays resolves to an exact number of weeks
      if (remainingWorkDays % 5 == 0)
        daysToAdd -= 2;
    }
  }
  startDate.setDate(startDate.getDate() + daysToAdd);
  return startDate;
};

// ---- Delivery date helpers (SOLID) ----
var EURO_ZONE_COUNTRIES = [
  'AT','BE','CY','DE','ES','FI','GR','IE','IT','LT','LU','LV','MT','NL','PT','SI','SK','MC'
];

var formatDateDDMMYYYY = function (date) {
  var dd = String(date.getDate()).padStart(2, '0');
  var mm = String(date.getMonth() + 1).padStart(2, '0');
  var yyyy = date.getFullYear();
  return dd + '/' + mm + '/' + yyyy;
};

var resolveLanguageCode = function () {
  try {
    if (window.AYAQ_LOC && AYAQ_LOC.language) return String(AYAQ_LOC.language).toLowerCase();
    var html = document && document.documentElement;
    if (html && typeof html.lang === 'string' && html.lang.length) {
      return html.lang.toLowerCase();
    }
  } catch (e) {}
  try {
    if (typeof Shopify !== 'undefined' && Shopify && Shopify.locale) {
      return String(Shopify.locale).toLowerCase();
    }
  } catch (e) {}
  try {
    if (typeof navigator !== 'undefined' && navigator.language) {
      return navigator.language.toLowerCase();
    }
  } catch (e) {}
  return 'fr';
};

var formatDateByLanguage = function (date, lang) {
  var locale = (lang && typeof lang === 'string') ? lang : undefined;
  try {
    return date.toLocaleDateString(locale, { year: 'numeric', month: 'long', day: 'numeric' });
  } catch (e1) {
    try {
      return date.toLocaleDateString(locale);
    } catch (e2) {
      return formatDateDDMMYYYY(date);
    }
  }
};

var resolveCountryIso = function () {
  // Try currently selected country from localization form
  try {
    if (window.AYAQ_LOC && AYAQ_LOC.country) return String(AYAQ_LOC.country).toUpperCase();
    var inputs = document.querySelectorAll('form.localization, form.localization-form, form[action*="localization"]');
    for (var i = 0; i < inputs.length; i++) {
      var el = inputs[i].querySelector('input[name="country_code"], select[name="country_code"]');
      if (el && el.value) {
        return String(el.value).toUpperCase();
      }
    }
  } catch (e) {}

  try {
    if (typeof geo_country_code === 'string' && geo_country_code.length) {
      return geo_country_code.toUpperCase();
    }
  } catch (e) {}

  // Fallback
  return 'FR';
};

var computeDeliveryMinWorkDays = function (countryIso) {
  var iso = (countryIso || '').toUpperCase();

  // Explicit country rules from shipping policy
  if (iso === 'JP') return 6; // Japon: aujourd'hui + 6 jours (ouvrés)
  if (iso === 'FR') return 2; // France: 2–5 j ouvrés (min 2)
  if (iso === 'CH') return 2; // Suisse: 2–5 j ouvrés (min 2)
  if (iso === 'UK' || iso === 'GB') return 1; // Royaume-Uni: 1–3 j ouvrés (min 1)
  if (iso === 'US' || iso === 'CA') return 4; // Amérique du Nord: 4–8 j ouvrés (min 4)

  // Euro zone (rest, excluding FR which is handled above): 4–8 j ouvrés (min 4)
  if (EURO_ZONE_COUNTRIES.indexOf(iso) >= 0 && iso !== 'FR') return 4;

  // Default fallback: 4 j ouvrés
  return 4;
};

var getDeliveryDate = function () {
  var today = new Date();
  var country = resolveCountryIso();
  var minWorkDays = computeDeliveryMinWorkDays(country);
  var estimatedDate = addWorkDays(today, minWorkDays);
  var lang = resolveLanguageCode();
  return formatDateByLanguage(estimatedDate, lang);
};

// Refresh all delivery date placeholders according to current language/country rules
var updateDeliveryDateSpans = function (scope) {
  try {
    if (typeof prevente !== 'undefined' && prevente) return;
  } catch (e) {}
  try {
    var root = scope || document;
    var d = getDeliveryDate();
    var nodes = root.querySelectorAll('.deliveryDateSpan');
    nodes.forEach(function (n) { n.textContent = d; });
  } catch (e) {}
};

// Observe <html lang> changes and common localization UI interactions to keep date in sync
var setupLanguageObserver = function () {
  try {
    var html = document && document.documentElement;
    if (!html) return;
    var lastLang = (html.lang || '').toLowerCase();
    var lastCountry = (window.AYAQ_LOC && AYAQ_LOC.country) ? String(AYAQ_LOC.country) : null;
    var obs = new MutationObserver(function () {
      var newLang = (html.lang || '').toLowerCase();
      if (newLang !== lastLang) {
        lastLang = newLang;
        updateDeliveryDateSpans();
      }
      var currCountry = (window.AYAQ_LOC && AYAQ_LOC.country) ? String(AYAQ_LOC.country) : null;
      if (currCountry !== lastCountry) {
        lastCountry = currCountry;
        updateDeliveryDateSpans();
      }
    });
    obs.observe(html, { attributes: true, attributeFilter: ['lang'] });
  } catch (e) {}

  // Fallback hooks for theme localization components
  try {
    document.addEventListener('change', function (ev) {
      var t = ev.target;
      if (!t) return;
      var form = t.closest && t.closest('form.localization-form');
      if (form && (t.name === 'locale_code' || t.name === 'language_code' || t.name === 'country_code')) {
        if (window.AYAQ_LOC) {
          try {
            if (t.name === 'country_code') AYAQ_LOC.country = t.value;
            if (t.name === 'locale_code' || t.name === 'language_code') AYAQ_LOC.language = t.value;
          } catch (e) {}
        }
        setTimeout(function () { updateDeliveryDateSpans(); }, 0);
      }
    }, true);
  } catch (e) {}
};

var displaySticky = function () {
  if (!variantSoldOut) {
    var shouldShow = false;
    var atc = document.getElementById('addToCart');
    var posScroll = $(document).scrollTop();
    
    if (atc) {
      var rect = atc.getBoundingClientRect();
      var inViewport = rect.top < window.innerHeight && rect.bottom > 0;
      shouldShow = !inViewport; // show sticky when main ATC not visible
    } else {
      // Fallback threshold if main ATC not found
      shouldShow = posScroll >= 200;
    }

    // Always hide at the top of the page so it disappears when scrolled to 0
    if (posScroll < 200) {
      shouldShow = false;
    }
    if (shouldShow) {
      $('.stickyatc').fadeIn(600);
      if (typeof showChat === 'function') showChat(false);
    }
    else {
      if (typeof showChat === 'function') showChat(true);
      $('.stickyatc').fadeOut(600);
    }
  }
};

document.addEventListener("DOMContentLoaded", function (event) {
  handleAccordeon();
  injectProductVideo();
  try { updateDeliveryDateSpans(); } catch (e) {}
  try { setupLanguageObserver(); } catch (e) {}
});


function handleAccordeon() {
  document.querySelectorAll('.accordion-button').forEach(button => {
    button.addEventListener('click', function () {
      const accordionContent = this.nextElementSibling;
      const icon = this.querySelector('.fas.fa-angle-down, .fas.fa-angle-up'); // Sélectionne uniquement l'icône angle

      this.classList.toggle('active');

      if (accordionContent.style.maxHeight) {
        accordionContent.style.maxHeight = null;
        icon.classList.remove('fa-angle-up');
        icon.classList.add('fa-angle-down');
      } else {
        accordionContent.style.maxHeight = accordionContent.scrollHeight + 'px';
        icon.classList.remove('fa-angle-down');
        icon.classList.add('fa-angle-up');
      }
    });
  });

  $("#linksize").click(function () {
    $("html, body").animate({ scrollTop: $("#ongletsize").offset().top }, 1000);
    $("#ongletsize").trigger("click");
  });

  var deliveryDate = getDeliveryDate();

  if (!prevente) {
    $(".deliveryDateSpan").html(deliveryDate);
  }

  $('#moredetails').click(function () {
    $('#details')[0].scrollIntoView({
      behavior: 'smooth'
    });
  });

  $("#addToCartSticky").addClass($("#addToCart").attr("class"));
  $('#addToCartSticky').click(function (e) {
    $("html, body").animate({ scrollTop: 0 }, 500);
    e.preventDefault();
  });
  $(window).scroll(function () {
    displaySticky();
  });
}

function injectProductVideo() {
  const autoplayBlocks = document.querySelectorAll('.deferred-media.autoplay');

  autoplayBlocks.forEach((block) => {
    const template = block.querySelector('template');
    if (!template) return;

    const content = template.content.cloneNode(true);

    // Remplace tout le contenu du bloc par la vidéo
    block.innerHTML = '';
    block.appendChild(content);
  });
}

